/*
 * Copyright 2019 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Catapult REST API Reference
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.7.15
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';
import UInt64DTO from './UInt64DTO';





/**
* The BlockchainScoreDTO model module.
* @module model/BlockchainScoreDTO
* @version 0.7.15
*/
export default class BlockchainScoreDTO {
    /**
    * Constructs a new <code>BlockchainScoreDTO</code>.
    * @alias module:model/BlockchainScoreDTO
    * @class
    * @param scoreHigh {module:model/UInt64DTO} 
    * @param scoreLow {module:model/UInt64DTO} 
    */

    constructor(scoreHigh, scoreLow) {
        

        
        

        this['scoreHigh'] = scoreHigh;this['scoreLow'] = scoreLow;

        
    }

    /**
    * Constructs a <code>BlockchainScoreDTO</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/BlockchainScoreDTO} obj Optional instance to populate.
    * @return {module:model/BlockchainScoreDTO} The populated <code>BlockchainScoreDTO</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BlockchainScoreDTO();

            
            
            

            if (data.hasOwnProperty('scoreHigh')) {
                obj['scoreHigh'] = UInt64DTO.constructFromObject(data['scoreHigh']);
            }
            if (data.hasOwnProperty('scoreLow')) {
                obj['scoreLow'] = UInt64DTO.constructFromObject(data['scoreLow']);
            }
        }
        return obj;
    }

    /**
    * @member {module:model/UInt64DTO} scoreHigh
    */
    scoreHigh = undefined;
    /**
    * @member {module:model/UInt64DTO} scoreLow
    */
    scoreLow = undefined;








}


